module.exports = __webpack_public_path__ + "static/media/transmission-fluid-exchange.c6454742.svg";